<!--  -->
<template>
  <div>
    <div class="head">
      <div class="head-layout">
        <img src="https://oss.cmef.com.cn/cloudExhibition/imgs/202103/338d8c90612041e4b6059d71dd8504a8.jpg" alt="" />
        <span style="color: #fff; font-size: 26px; margin-left: 10px">{{name}}</span>
      </div>
    </div>
    <div class="layout">
      <div class="" style="min-height: 80px">
        <div style="position: relative">
          <!-- <Breadcrumb>
            <BreadcrumbItem>首页</BreadcrumbItem>
            <BreadcrumbItem>管理</BreadcrumbItem>
            <BreadcrumbItem>证件申请</BreadcrumbItem>
          </Breadcrumb> -->
          <div class="header-tool-title">证件导入/{{ bageType }}</div>
          <div class="back" @click="back">返回首页</div>
        </div>
      </div>
    </div>
    <div class="body">
      <template v-if="BadgeId != 3">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false" :loading="loading">
          <template slot-scope="{ row, index }" slot="badgeType">{{
            row.deExCardDown.badgeType
          }}</template>
          <template slot-scope="{ row, index }" slot="companyName">{{
            row.deExCardDown.companyName
          }}</template>
          <template slot-scope="{ row, index }" slot="boothCode">{{
            row.deExCardDown.boothCode
          }}</template>
          <template slot-scope="{ row, index }" slot="firstName">{{
            row.deExCardDown.firstName
          }}</template>
          <template slot-scope="{ row, index }" slot="phone">{{
            row.deExCardDown.tel
          }}</template>
          <template slot-scope="{ row, index }" slot="email">{{
            row.deExCardDown.email
          }}</template>
          <template slot-scope="{ row, index }" slot="jobTitle">{{
            row.deExCardDown.jobTitle
          }}</template>
          <template slot-scope="{ row, index }" slot="importResultState">{{
            row.importResultState
          }}</template>
          <template slot-scope="{ row, index }" slot="importResultMess">{{
            row.importResultMess
          }}</template>
        </Table>
      </template>
      <template v-else>
        <Table :border="false" :columns="columns" :data="list" :disabled-hover="false" :loading="loading">
          <template slot-scope="{ row, index }" slot="badgeType">{{
            row.deExCardDown.badgeType
          }}</template>
          <template slot-scope="{ row, index }" slot="companyName">{{
            row.deExCardDown.companyName
          }}</template>
          <template slot-scope="{ row, index }" slot="boothCode">{{
            row.deExCardDown.boothCode
          }}</template>
          <template slot-scope="{ row, index }" slot="firstName">{{
            row.deExCardDown.firstName
          }}</template>
          <template slot-scope="{ row, index }" slot="phone">{{
            row.deExCardDown.tel
          }}</template>
          <template slot-scope="{ row, index }" slot="email">{{
            row.deExCardDown.email
          }}</template>
          <template slot-scope="{ row, index }" slot="jobTitle">{{
            row.deExCardDown.jobTitle
          }}</template>
          <template slot-scope="{ row, index }" slot="country">{{
            row.deExCardDown.country
          }}</template>
          <template slot-scope="{ row, index }" slot="department">{{
            row.deExCardDown.department
          }}</template>
          <template slot-scope="{ row, index }" slot="importResultState">{{
            row.importResultState
          }}</template>
          <template slot-scope="{ row, index }" slot="importResultMess">{{
            row.importResultMess
          }}</template>
        </Table>
      </template>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data () {
    return {
      columns1: [
        {
          title: "证件类型",
          key: "badgeType",
          align: "center",
          slot: "badgeType",
        },
        {
          title: "公司名称",
          key: "companyName",
          align: "center",
          slot: "companyName",
        },
        {
          title: "展位号",
          key: "boothCode",
          align: "center",
          slot: "boothCode",
        },
        {
          title: "姓名",
          key: "firstName",
          align: "center",
          slot: "firstName",
          //width: "300",
        },
        {
          title: "电话",
          key: "phone",
          align: "center",
          slot: "phone",
        },
        {
          title: "邮箱",
          key: "email",
          align: "center",
          slot: "email",
        },
        {
          title: "职务",
          key: "jobTitle",
          align: "center",
          slot: "jobTitle",
        },
        {
          title: "状态",
          key: "importResultState",
          align: "center",
          slot: "importResultState",
        },
        {
          title: "原因",
          key: "importResultMess",
          align: "center",
          slot: "importResultMess",
        },
      ],
      columns: [
        {
          title: "证件类型",
          key: "badgeType",
          align: "center",
          slot: "badgeType",
        },
        {
          title: "公司名称",
          key: "companyName",
          align: "center",
          slot: "companyName",
        },
        {
          title: "展位号",
          key: "boothCode",
          align: "center",
          slot: "boothCode",
        },
        {
          title: "姓名",
          key: "firstName",
          align: "center",
          slot: "firstName",
          //width: "300",
        },
        {
          title: "电话",
          key: "phone",
          align: "center",
          slot: "phone",
        },
        {
          title: "邮箱",
          key: "email",
          align: "center",
          slot: "email",
        },
        {
          title: "职务",
          key: "jobTitle",
          align: "center",
          slot: "jobTitle",
        },
        {
          title: "部门",
          key: "department",
          align: "center",
          slot: "department",
        },
        {
          title: "国家",
          key: "country",
          align: "center",
          slot: "country",
        },
        {
          title: "状态",
          key: "importResultState",
          align: "center",
          slot: "importResultState",
        },
        {
          title: "原因",
          key: "importResultMess",
          align: "center",
          slot: "importResultMess",
        },
      ],
      list: [],
      BadgeType: "",
      loading: true,
      name: ''
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created () {
    this.init();
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted () { },
  computed: {
    ...mapGetters({}),
    exhibitionId () {
      return this.$route.query.exhibitionId;
    },
    BadgeId () {
      return this.$route.query.BadgeId;
    },
  },
  methods: {
    ...mapActions({
      getDeExCardDownImportNew: "exhibitionModule/getDeExCardDownImportNew",
      getExhibitionByIdNew: "exhibitionModule/getExhibitionByIdNew",
    }),

    back () {
      this.$router.push("/exhibition/CertificateExport?exhibitionId=" + this.exhibitionId);
    },
    async init () {
      if (this.BadgeId == 1) {
        this.bageType = "展商证";
      }
      if (this.BadgeId == 2) {
        this.bageType = "特邀嘉宾";
      }
      if (this.BadgeId == 3) {
        this.bageType = "海外/港澳台认证";
      }
      if (this.BadgeId == 4) {
        this.bageType = "VIP";
      }
      let data1 = await this.getExhibitionByIdNew(this.exhibitionId);
      if (data1.name) {
        this.name = data1.name;
      }
      let uploadPath = localStorage.getItem("uploadPath").split("key=");
      if (this.BadgeId == 1) {
        this.BadgeType = "展商证";
      } else if (this.BadgeId == 2) {
        this.BadgeType = "特邀嘉宾";
      } else if (this.BadgeId == 3) {
        this.BadgeType = "海外及港澳台地区展商证/The Certificate of Chinese Hong Kong, Macau, Taiwan and Overseas Exhibitor";
      } else if (this.BadgeId == 4) {
        this.BadgeType = "VIP";
      }

      let opt = {
        ExhibitionId: this.exhibitionId,
        FileKey: uploadPath[0],
        BadgeType: this.BadgeType,
      };
      
      let data = await this.getDeExCardDownImportNew(opt);
      console.log(data, "获取的结果");
      if (data.successed) {

        this.list = data.info;
        console.log(this.list[0].deExCardDown.badgeType);
        this.loading = false
      }
      else {
        this.loading = false
      }
    },
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */
.head {
  height: 100px;
  background: #333;
  &-layout {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    height: 100px;
    img {
      width: 70px;
      height: 70px;
    }
  }
}
.layout {
  margin: 0 auto;
  max-width: 1200px;
}
.header-tool {
}
.back {
  position: absolute;
  right: 20px;
  top: 10px;
  cursor: pointer;
  padding: 5px 10px;

  background: #fff;
}
.body {
  background: #fff;
  margin: 0 auto;
  max-width: 1200px;
  min-height: 450px;
  padding: 30px;
}
.submit {
  margin-top: 30px;
  width: 150px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: red;
}
</style>
